import config from '@/config';

const baseUrl = `${config.host}/excel`;

export const exportFile = {
	exportAnswer(surveyId, startTime = '', endTime = '', activityTitle = '', platformOrigin, auditStatus) {
		let url = `${baseUrl}/shop/survey/export?surveyId=${surveyId}`;
		if (startTime) {
			url += `&startTime=${startTime / 1000}`;
		}
		if (endTime) {
			url += `&endTime=${endTime / 1000}`;
		}
		if (activityTitle) {
			url += `&activityTitle=${activityTitle}`;
		}
		if (platformOrigin === 0 || platformOrigin === 1) {
			url += `&platformOrigin=${platformOrigin}`;
		}
		if ([0, 1, 2].includes(auditStatus)) {
			url += `&auditStatus=${auditStatus}`;
		}
		console.log(url);
		return url;
	},
};
